__turbopack_context__.v({
  "list": "ctaBlock-module-scss-module__Tu7hNG__list",
});
